import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import { Product, ProductProperty } from '@/models/product';
import { asyncForEach, validateFileName } from '@/utils';
import lodash, { forEach, isEmpty } from 'lodash';
var slugify = require('slugify');
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment-timezone';

export interface ProductState {
    activeQuotation: {
        products: Array<any>;
        clientName: string;
        clientEmail: string;
        clientPhone: string;
        note: string;
        intelisis: boolean;
        globalDiscount: number;
    };
    activeQuotationLoading: boolean;

    activeProduct: Partial<Product>;
    activeProductLoading: boolean;

    cacheProducts: Array<Product>;
    cacheProductsLoading: boolean;
    allProducts: Array<Product>;
    allProductsLoading: boolean;

    productsPerPage: number;
    productsPage: number;
    productsTotal: number;

    cacheClients: Array<any>;
    client: any;
    users_intelisis: any;
    message: string;
}

const defaultProduct = {
    name: '',
    sku: null,
    stock_total: 0,
    stocks: [],
    gallery: [],
    complete_gallery: [],
    keywords: [],
    manufacturersku: '',
    price: 0,
    in_ecommerce: 0,
    properties: [],
    data_sheet: null,
    ean_upc: 0,
};

const state: ProductState = {
    // activeQuotation
    activeQuotation: {
        clientName: '',
        clientEmail: '',
        clientPhone: '',
        products: [],
        note: '',
        intelisis: false,
        globalDiscount: 0
    },
    activeQuotationLoading: false,
    // activeProduct
    activeProduct: defaultProduct,
    activeProductLoading: false,
    // allProducts
    cacheProducts: [],
    cacheProductsLoading: false,
    // allProducts
    allProducts: [],
    allProductsLoading: false,
    productsPerPage: 1,
    productsPage: 1,
    productsTotal: 1,
    cacheClients: [],
    client: {
        cliente: null,
        listapreciosesp: null
    },
    users_intelisis: [],
    message: ''
};

const mutations = {
    TOGGLE_ALL_PRODUCTS_LOADING(state: ProductState, data: boolean) {
        state.allProductsLoading = data;
    },
    SET_ALL_PRODUCTS(state: ProductState, data: PaginatedCollection) {
        state.allProducts = data.items;
        state.productsPerPage = data.perPage;
        state.productsPage = data.currentPage;
        state.productsTotal = data.totalItems;
        state.message = data.message;
    },
    SET_CACHE_PRODUCTS(state: ProductState, data: any) {
        // let cacheProducts = [...state.cacheProducts, ...data].map((p: any) => {
        let cacheProducts = [...data].map((p: any) => {
            return {
                ...p,
                label: `${p.id} ${p.name}`,
            };
        });
        state.cacheProducts = lodash.uniqBy(cacheProducts, 'id');
    },
    TOGGLE_CACHE_PRODUCTS_LOADING(state: ProductState, data: boolean) {
        state.cacheProductsLoading = data;
    },
    SET_ACTIVE_PRODUCT(state: ProductState, product: Product) {
        state.activeProduct = product;
        console.log('SET_ACTIVE_PRODUCT', state.activeProduct);
    },
    SET_ACTIVE_QUOTATION(state: ProductState, quotation: any) {
        state.activeQuotation = quotation;
        console.log('SET_ACTIVE_QUOTATION', state.activeQuotation);
    },
    TOGGLE_ACTIVE_PRODUCT_LOADING(state: ProductState, data: boolean) {
        state.activeProductLoading = data;
    },
    SET_CACHE_CLIENTS(state: ProductState, data: any) {
        let cacheClients = [...data].map((client: any) => {
            return {
                ...client,
                label: `${client.cliente} ${client.nombre} ${client.rfc}`,
            };
        });
        state.cacheClients = lodash.uniqBy(cacheClients, 'cliente');
    },
    SET_CLIENT(state: ProductState, data: any) {
        state.client = data;
    },
    SET_USERS_INTELISIS(state: ProductState, data: any) {
        state.users_intelisis = data.users;
    },
};

const actions = {
    async getOne({ _, commit }: any, sku: string | null = null) {
        console.log('getOne', sku);
        commit('TOGGLE_ACTIVE_PRODUCT_LOADING', true);
        if (sku != null) {
            await directusApi('GET', `custom/legacy-intelisis/${sku}`)
                .then(async res => {
                    if (res.data.data.data_sheet) {
                        await directusApi('GET', `files?filter[id][_eq]=${res.data.data.data_sheet}&limit=1`)
                            .then(async (resFile: any) => {
                                res.data.data.data_sheet = {
                                    id: res.data.data.data_sheet,
                                    name: resFile.data.data[0].filename_download,
                                };
                                commit('SET_ACTIVE_PRODUCT', res.data.data);
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    } else {
                        commit('SET_ACTIVE_PRODUCT', res.data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_PRODUCT', defaultProduct);
            commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
        }
    },

    async cacheAll({ _, commit }: any, { search, limit, product }: any) {
        commit('TOGGLE_CACHE_PRODUCTS_LOADING', true);
        let idsNotShow = [];
        if (product) {
            idsNotShow.push(product.id);
        }
        let filter: any = { _and: [] };
        if (search !== null) {
            filter._and.push({
                _or: [{ name: { _contains: search } }, { id: { _contains: search } }],
            });
        }

        let endpoint = `items/products?filter=${JSON.stringify(filter)}&limit=${limit}`;

        // console.log(endpoint);
        await directusApi('GET', endpoint)
            .then(res => {
                let productsCache = res.data.data;
                // console.log({ idsNotShow });
                if (idsNotShow.length > 0) {
                    productsCache = productsCache.filter(function (word: any) {
                        return !idsNotShow.includes(word.id);
                    });
                }
                commit('SET_CACHE_PRODUCTS', productsCache);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_CACHE_PRODUCTS_LOADING', false);
            });
    },
    async fetchAll({ _, commit }: any, { search, page, sortName, sortValue }: any) {
        commit('TOGGLE_ALL_PRODUCTS_LOADING', true);
        let params = {};

        if (search) {
            search = search.toUpperCase();
            params = { ...params, search };
        }
        // if (search) params = { ...params, search }
        if (page) params = { ...params, page };
        if (sortName) params = { ...params, sortName };
        if (sortValue) params = { ...params, sortValue };
        params = { ...params };
        let query = new URLSearchParams(params);

        let endpoint = `custom/legacy-intelisis?${query}`;

        await directusApi('GET', endpoint)
            .then(response => {
                const apiResponse = response.data;
                // console.log('fetchAll', apiResponse);
                commit('SET_ALL_PRODUCTS', {
                    items: apiResponse.data,
                    perPage: apiResponse.meta?.limit,
                    currentPage: apiResponse.meta?.page,
                    totalItems: apiResponse.meta?.total,
                    message: apiResponse.message
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
            });
    },
    async cacheAllClients({ _, commit }: any, { search, limit }: any) {
        //commit('TOGGLE_CACHE_PRODUCTS_LOADING', true);
        let filter: any = { _and: [] };
        if (search !== null) {
            filter._and.push({
                _or: [
                    { cliente: { _contains: search } },
                    { nombre: { _contains: search } },
                    { rfc: { _contains: search } }
                ],
            });
        }

        let endpoint = `items/cte?filter=${JSON.stringify(filter)}&limit=${limit}`;
        await directusApi('GET', endpoint)
            .then(res => {
                let clientsCache = res.data.data;
                commit('SET_CACHE_CLIENTS', clientsCache);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                //commit('TOGGLE_CACHE_PRODUCTS_LOADING', false);
            });
    },
    async getClient({ _, commit }: any, data: any) {
        commit('TOGGLE_ALL_PRODUCTS_LOADING', true);
        if (data.client) {
            data.client = data.client.toUpperCase();
            await directusApi('GET', `items/cte/${data.client}`)
                .then(res => {
                    commit('SET_CLIENT', res.data.data);
                    commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
                })
                .catch(err => {
                    data.vm.$bvToast.toast('No se ha encontrado ninguna coincidencia.', {
                        title: `Lo sentimos.`,
                        variant: 'warning',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                    commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
                });
        } else {
            commit('SET_CLIENT', { cliente: null, listapreciosesp: null });
            commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
        }
    },
    async setQuotation({ _, commit }: any, quotation: any) {
        console.log('SET_ACTIVE_QUOTATION', quotation);
        commit('SET_ACTIVE_QUOTATION', quotation);
    },
    async postOneOrder({ _, commit }: any, data: any) {
        let order_items: any = [];
        let user = data.user;
        data.newOrder.products.forEach((product: any) => {
            order_items.push({
                id: product.sku,
                description: product.name,
                price: parseFloat(product.price),
                qty: parseInt(product.qty),
            });
        });
        let newOrder = {
            id: Math.floor(1000000000000000 + Math.random() * 9000000000000000),
            order_items,
            order_date: moment().format('YYYY/MM/DD H:mm:ss'),
            logistic_type: 'cotizador',
            order_status: 'paid', //check status
            status: 'procesando_en_prodelec',
            comments: data.newOrder.note,
            order_user: user.id
        };
        // await directusApi('POST', `items/mercadolibre_orders`, {
        await directusApi('POST', `items/prodelec_orders`, {
            id: newOrder.id,
            order_items: newOrder.order_items,
            order_date: newOrder.order_date,
            logistic_type: newOrder.logistic_type,
            order_status: newOrder.order_status,
            status: newOrder.status,
            comments: newOrder.comments,
            intelisis_movement: 'null',
            order_user: newOrder.order_user,
            created_at: moment().format('YYYY/MM/DD H:mm:ss')
        })
            .then(async (order: any) => {
                data.vm.$bvToast.toast('Se ha creado exitosamente', {
                    title: `Orden creada`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            })
            .catch(err => {
                console.log(err);
            });
        /*
        commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', true);
        await directusApi('POST', `items/products_sectors`, {
            name: data.data.name,
            slug: data.data.slug
        })
            .then(async (sector: any) => {
                data.vm.$bvToast.toast('Se ha creado exitosamente', {
                    title: `Sector creado`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                commit('SET_ACTIVE_PRODUCT_SECTOR', sector.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', false);
            });*/
    },
    async postQuotation({ _, commit }: any, data: any) {
        await directusApi('POST', `custom/legacy-intelisis/intelisisQuotation`, data.payload).then((response: any) => {
            data.vm.$bvToast.toast('Se ha creado exitosamente', {
                title: `Cotización creada`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }).catch(err => {
            console.log(err);
        });;
    },
    async getUsersIntelisis({ _, commit }:any) {
        commit('TOGGLE_ALL_PRODUCTS_LOADING', true);
        await directusApi('GET', `items/intelisis_users`)
        .then(response => {
            const apiResponse = response.data;
            commit('SET_USERS_INTELISIS', {
               users: apiResponse.data
            });
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
